import { FC } from 'react';

import { Row, Tag } from 'antd';
import { Card } from '@hdi-seguros/web-components.card';
import { PolicyStates } from '../../../../../shared/interfaces';
import { _renderColumns } from '../../../../../shared/components/CardRenderWithButton/renderSections';

interface VendorCardProps {
    title: string;
    article: string | undefined;
    tags: PolicyStates[] | undefined;
    actions?: any;
    loading: boolean | undefined;
    columnsData: Array<any>;
}


const _renderTitle = (title: string) => (
    <>
      <Tag color='grey'>{title}</Tag>
    </>
);

export const VendorCardComponent: FC<VendorCardProps> = ({title, article, tags, actions, loading, columnsData}) => {
    return (
      <Card
        title={_renderTitle(title)}
        tags={tags as any}
        actions={actions}
        loading={loading}
        style={{
          marginBottom: 20,
          width: '100%',
        }}
      >
        <Row style={{ marginLeft: 0 }} gutter={[10, 10]}>
          {_renderColumns(columnsData)}
        </Row>
      </Card>
    )
}